import useLocalStorageState from "use-local-storage-state";
import useCurrentUser from "./useCurrentUser";

const KEY = "table-preferences";

export enum EPaginationStyle {
  TOP = "TOP",
  BOTTOM = "BOTTOM",
  DOUBLE = "DOUBLE",
}

const DEFAULTS = {
  disableMultipleSelection: false,
  paginationStyle: EPaginationStyle.BOTTOM,
  allowPinnedColumns: true,
  showColumnFilters: true,
  selectionOnClickAnyCell: true,
};

export default function useTablePreferences() {
  const { userInfo } = useCurrentUser();

  const [tablePreferences, setTablePreferences] = useLocalStorageState(
    `${userInfo?._id}-${KEY}`,
    { defaultValue: DEFAULTS }
  );

  return {
    hasDoublePaginationEnabled:
      tablePreferences?.paginationStyle === EPaginationStyle.DOUBLE,
    hasBottomPagination:
      tablePreferences?.paginationStyle === EPaginationStyle.BOTTOM,
    hasTopPagination:
      tablePreferences?.paginationStyle === EPaginationStyle.TOP,
    allowPinnedColumns: !!tablePreferences?.allowPinnedColumns,
    showColumnFilters: !!tablePreferences?.showColumnFilters,
    selectOnRowClick: !!tablePreferences?.selectionOnClickAnyCell,
    allowMultipleSelection: !tablePreferences?.disableMultipleSelection,
    paginationStyle: tablePreferences?.paginationStyle,
    updateTablePreferences: (newState: Partial<typeof DEFAULTS>) => {
      setTablePreferences((prev: any) => ({ ...prev, ...newState }));
    },
  };
}
